var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['app', `lang-${_vm.$i18n.locale}`],attrs:{"id":"app"}},[_c('SiteHeader'),_c('main',{staticClass:"page-main"},[_c('router-view')],1),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }